"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: zetachain-cctx-proto/proto/v1/zetachain-cctx.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtocolContractVersion = exports.InboundStatus = exports.ConfirmationMode = exports.TxFinalizationStatus = exports.CctxStatusReduced = exports.CctxStatus = exports.CoinType = exports.Direction = void 0;
/* eslint-disable */
var Direction;
(function (Direction) {
    Direction["ASC"] = "ASC";
    Direction["DESC"] = "DESC";
    Direction["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Direction || (exports.Direction = Direction = {}));
var CoinType;
(function (CoinType) {
    CoinType["ZETA"] = "ZETA";
    /** GAS - Ether, BNB, Matic, Klay, BTC, etc */
    CoinType["GAS"] = "GAS";
    /** ERC20 - ERC20 token */
    CoinType["ERC20"] = "ERC20";
    /** CMD - no asset, used for admin command */
    CoinType["CMD"] = "CMD";
    /** NO_ASSET_CALL - no asset, used for contract call */
    CoinType["NO_ASSET_CALL"] = "NO_ASSET_CALL";
    CoinType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CoinType || (exports.CoinType = CoinType = {}));
var CctxStatus;
(function (CctxStatus) {
    /** PENDING_INBOUND - some observer sees inbound tx */
    CctxStatus["PENDING_INBOUND"] = "PENDING_INBOUND";
    /** PENDING_OUTBOUND - super majority observer see inbound tx */
    CctxStatus["PENDING_OUTBOUND"] = "PENDING_OUTBOUND";
    /** OUTBOUND_MINED - the corresponding outbound tx is mined */
    CctxStatus["OUTBOUND_MINED"] = "OUTBOUND_MINED";
    /** PENDING_REVERT - outbound cannot succeed; should revert inbound */
    CctxStatus["PENDING_REVERT"] = "PENDING_REVERT";
    /** REVERTED - inbound reverted. */
    CctxStatus["REVERTED"] = "REVERTED";
    /** ABORTED - inbound tx error or invalid paramters and cannot revert; just abort. */
    CctxStatus["ABORTED"] = "ABORTED";
    CctxStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CctxStatus || (exports.CctxStatus = CctxStatus = {}));
var CctxStatusReduced;
(function (CctxStatusReduced) {
    CctxStatusReduced["PENDING"] = "PENDING";
    CctxStatusReduced["SUCCESS"] = "SUCCESS";
    CctxStatusReduced["FAILED"] = "FAILED";
    CctxStatusReduced["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CctxStatusReduced || (exports.CctxStatusReduced = CctxStatusReduced = {}));
var TxFinalizationStatus;
(function (TxFinalizationStatus) {
    /** NOT_FINALIZED - the corresponding tx is not finalized */
    TxFinalizationStatus["NOT_FINALIZED"] = "NOT_FINALIZED";
    /** FINALIZED - the corresponding tx is finalized but not executed yet */
    TxFinalizationStatus["FINALIZED"] = "FINALIZED";
    /** EXECUTED - the corresponding tx is executed */
    TxFinalizationStatus["EXECUTED"] = "EXECUTED";
    TxFinalizationStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TxFinalizationStatus || (exports.TxFinalizationStatus = TxFinalizationStatus = {}));
var ConfirmationMode;
(function (ConfirmationMode) {
    /** SAFE - an inbound/outbound is confirmed using safe confirmation count */
    ConfirmationMode["SAFE"] = "SAFE";
    /** FAST - an inbound/outbound is confirmed using fast confirmation count */
    ConfirmationMode["FAST"] = "FAST";
    ConfirmationMode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ConfirmationMode || (exports.ConfirmationMode = ConfirmationMode = {}));
/** InboundStatus represents the status of an observed inbound */
var InboundStatus;
(function (InboundStatus) {
    InboundStatus["INBOUND_SUCCESS"] = "INBOUND_SUCCESS";
    /**
     * INSUFFICIENT_DEPOSITOR_FEE - this field is specifically for Bitcoin when the deposit amount is less than
     * depositor fee
     */
    InboundStatus["INSUFFICIENT_DEPOSITOR_FEE"] = "INSUFFICIENT_DEPOSITOR_FEE";
    /** INVALID_RECEIVER_ADDRESS - the receiver address parsed from the inbound is invalid */
    InboundStatus["INVALID_RECEIVER_ADDRESS"] = "INVALID_RECEIVER_ADDRESS";
    /** INVALID_MEMO - parse memo is invalid */
    InboundStatus["INVALID_MEMO"] = "INVALID_MEMO";
    InboundStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InboundStatus || (exports.InboundStatus = InboundStatus = {}));
/**
 * ProtocolContractVersion represents the version of the protocol contract used
 * for cctx workflow
 */
var ProtocolContractVersion;
(function (ProtocolContractVersion) {
    ProtocolContractVersion["V1"] = "V1";
    ProtocolContractVersion["V2"] = "V2";
    ProtocolContractVersion["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProtocolContractVersion || (exports.ProtocolContractVersion = ProtocolContractVersion = {}));
